const GUEST_INFO_SHEET = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRgN22wu_GACml1iGLToUyovXXkZ6Wsze3Oq0GOjb3Jhixmj0uptsN2pq0dIkwxFkc-dGqhuQKJkkos/pub?single=true&output=csv';
const GOOGLE_FORM_SHEET = 'https://docs.google.com/forms/u/2/d/e/1FAIpQLScMzdgQYU4aQMAwrgDCuGIApxnCTW1-hYbzUVxscjj7hfkbkw/formResponse';

export {
    GUEST_INFO_SHEET,
    GOOGLE_FORM_SHEET
};
